import { render, staticRenderFns } from "./ErrorCounseling.vue?vue&type=template&id=65b928a1&scoped=true&"
import script from "./ErrorCounseling.vue?vue&type=script&lang=js&"
export * from "./ErrorCounseling.vue?vue&type=script&lang=js&"
import style0 from "./ErrorCounseling.vue?vue&type=style&index=0&id=65b928a1&lang=less&scoped=true&"
import style1 from "./ErrorCounseling.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b928a1",
  null
  
)

export default component.exports